// @flow

// eslint-disable-next-line no-unused-vars
const noop = (...args: Array<any>): any => {};

export { noop };
